'use client'
import React,{useState} from 'react';
import EmployAside from '../aside';
import Communication from './communication';

const MaCommunication = () => {
  const [isOpenSidebar,setIsOpenSidebar] = useState(false);
  return (    

    <div className='main-page-wrapper'>
      <EmployAside isOpenSidebar={isOpenSidebar} setIsOpenSidebar={setIsOpenSidebar}/>

      <Communication setIsOpenSidebar={setIsOpenSidebar}/>
    </div>    
  );
};

export default MaCommunication;